
<template>
  <VirtualList
    :list="list"
    :dataComponent="dataComponent"
    @getData="getData"
    :finished="finished"
  />
</template>

<script>
import VirtualList from "@/components/VirtualList";
import dataComponent from "./AftSaleItem";
import { StoreAfterSaleList } from "@/api/order/afterSale";
import { validPhone, validBackstageOrderNo } from "@/utils/vaildate";
export default {
  components: { VirtualList },
  props: {
    tabType: {
      type: [String, Number],
      require: true,
    },
    searchValue: {
      type: String,
    },
  },
  data() {
    return {
      dataComponent,
      list: [],
      finished: false,
      pagination: {
        page: 0,
        size: 10,
      },
    };
  },
  methods: {
    tabTypeChange() {
      this.list = [];
      this.finished = false;
      this.pagination.page = 0;
      this.getData();
    },
    getData() {
      const params = {
        ...this.pagination,
        state: null,
      };
      if (this.tabType) {
        params.state = this.tabType;
      }

      if (this.searchValue) {
        if (validPhone(this.searchValue)) {
          params.mobile = this.searchValue;
        } else if (validBackstageOrderNo(this.searchValue)) {
          params.orderNo = this.searchValue;
        } else {
          params.recipient = this.searchValue;
        }
      }
      this.StoreAfterSaleList(params);
    },

    StoreAfterSaleList(params) {
      StoreAfterSaleList(params).then((res) => {
        res.data.content.map((item) => {
          this.converData(item);
        });
        this.list.push(...res.data.content);
        if (res.data.content.length < this.pagination.size) {
          this.finished = true;
        } else {
          this.pagination.page++;
        }
      });
    },
    converData(data) {
      data.orderItemTotal = data.orderItems.reduce(
        (prev, cur) => Number(prev) + Number(cur.qty),
        0
      );
      return data;
    },
  },
};
</script>

<style>
</style>
